import{jsx as c}from"react/jsx-runtime";import n from"styled-components";import{Button as v}from"../Button/index.js";import{forwardRef as b}from"react";import{hexToRGB as f}from"../../utils/utils.js";import"../../theme.js";import"../Spinner/index.js";import"../../typography/ButtonText/index.js";import"../Button/styles.js";const $=n.li`
  list-style-type: none;
`,h=n(v)`
  && {
    margin-bottom: -3px;
    padding: 0.875rem 1.375rem;
    border-bottom: ${({theme:t,isActive:o,$activeColor:e,$activeColorShade:r})=>o?`3px solid ${t.colors[e][r]}`:"3px solid transparent"};
    transition:
      color 0.3s ease,
      border 0.3s ease;

    :focus-visible {
      ${({theme:t,isActive:o,$activeColor:e,$activeColorShade:r})=>!o&&`background-color: ${f(t.colors[e][r],.1)};
      `}
    }
  }
`,d=b(({label:t,index:o=-1,isActive:e=!1,onClick:r,activeColor:a="secondary",activeColorShade:l="mainAlt",isDisabled:m=!1,onKeyUp:s},p)=>c($,{role:"presentation",children:c(h,{id:`tab-${o}`,role:"tab","aria-selected":e,"aria-controls":`tabpanel-${o}`,tabIndex:e?0:-1,isActive:e,onClick:i=>r&&r(i,o),$activeColor:a,$activeColorShade:l,isDisabled:m,variant:"flat",color:e?a:"neutral",colorShade:l,onKeyUp:i=>s&&s(i,o),ref:p,noRadius:!0,children:t})}));d.displayName="Tab";export{d as default};
